import Rule from "../../../common/rule";

export default class StartKickOff extends Rule {
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.triggerKO = true;
        gameContext.fieldPosition = !gameContext.homeTeamHasPossession
            ? gameContext.getFieldLength() -
              gameContext.gameConfig.spots.kickoff
            : gameContext.gameConfig.spots.kickoff;
    }
}
